import useReadQna from "../../hooks/useReadQna";

export default function SearchFilter() {
    const {searchParam, setSearchParam, search} = useReadQna();

    return <div className="fiter_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">1:1문의 검색</h3>
            <div className="filter_toolbar"></div>
        </div>
        <div className="row">
            <div className="col-6">
                <div className="frm_row search justify-content-start">
                    <label htmlFor="" className="form-label frm_label">상태</label>
                    <select
                        className="form-select"
                        value={searchParam.keywordType}
                        onChange={(e) => setSearchParam((prev) => ({...prev, keywordType: e.target.value}))}
                    >
                        <option value={"0"}>전체</option>
                        <option value={"1"}>접수</option>
                        <option value={"2"}>진행</option>
                        <option value={"3"}>완료</option>
                    </select>
                </div>
            </div>
            <div className="col-6">
                <div className="frm_row">
                    <label htmlFor="" className="form-label frm_label">등록기간</label>
                    <div className="frm_field input_date">
                        <input
                            type="date"
                            className="form-control"
                            value={searchParam.startAt}
                            onChange={(e) => setSearchParam((prev) => ({...prev, startAt: e.target.value}))}/>
                        <span className="txt_range">~</span>
                        <input
                            type="date"
                            className="form-control me-0"
                            value={searchParam.endAt}
                            onChange={(e) => setSearchParam((prev) => ({...prev, endAt: e.target.value}))}/>
                        <button className="btn btn-info btn_search" onClick={search}>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
}